<template>
  <header class="mediaHeader container">
    <nuxt-link :to="link('Home')" :aria-label="$t('homepage')">
      <Icon name="logo" class="mediaHeader__Logo" />
    </nuxt-link>

    <div class="mediaHeader__ButtonsWrapper header__RightSideButtons">
      <div class="headerNavigation__LanguageSelector" :class="{'isActive': languageSelectorOpen}" v-click-outside="() => closeLanguageSelector()">
        <button :aria-label="$t('selectLanguage')" @click="languageSelectorOpen = !languageSelectorOpen">
          <Icon name="globe" />
          <span>{{ selectedLanguage }}</span>
        </button>
        <ul class="headerNavigation__LanguageOptions">
          <li v-for="(language, key) in availableLanguages">
            <nuxt-link :to="language" @click="selectedLanguage = key" :class="{'isActive': selectedLanguage === key}">
              {{ $t(`languages.${ key }`) }}
            </nuxt-link>
          </li>
        </ul>
      </div>

      <button v-if="template !== 'MediaAlbumLogin'" class="mediaHeader__LogoutButton" :aria-label="$t('header.logout')" @click="logout">
        <Icon name="profile" />
        <span>{{ $t('header.logout') }}</span>
      </button>
    </div>
  </header>
</template>

<script setup>
  const { page, template } = usePage();
  const { link } = useSetup();
  const { lang } = useLanguage();
  const { logout } = useAuth('local')
  const selectedLanguage = ref('hr');
  const languageSelectorOpen = ref(false);

  const availableLanguages = computed(() => {
    if (!page.value?.language_switcher) return null;
    const supportedLanguages = ['hr', 'en'];
    return Object.fromEntries(Object.entries(page.value.language_switcher).filter(([key, value]) => supportedLanguages.includes(key)));
  });

  function closeLanguageSelector() {
    languageSelectorOpen.value = false;
  }

  onMounted(() => {
    if (lang?.value) selectedLanguage.value = lang.value;
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_mediaHeader.scss');
</style>